import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "image-compressor",
  title: "Image Compressor",
  pageHeading: "Free Image Compressor",
  description:
    "Compress images to a target file size in KB or choose your own quality, then download optimized JPG, PNG, and WebP files.",
  seoTitle: "Compress Image to Target Size in KB - Free Online",
  seoDescription:
    "Compress an image to 20KB, 50KB, 100KB, 200KB or a custom target. Reduce JPG, PNG and WebP file size privately in your browser.",
  featureList: [
    "Batch JPG, PNG, and WebP compression",
    "Image quality control",
    "Custom target file size in KB",
    "Proportional image resizing",
    "Before-and-after file size comparison",
    "Individual and ZIP downloads",
    "Browser-only image processing",
  ],
  category: "Images",
} satisfies ToolMeta;
